import CustomCard from "@/components/CustomCardComponent/CustomCard";
import { Box, Link, Typography } from "@mui/material";

const NoContractAffiliationCard = () => {
    return (
        <CustomCard sx={{ padding: '16px 32px' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                <Box display="flex" alignItems="center">
                    <Typography variant="h5" sx={{ fontSize: '18px', marginRight: '8px' }}>
                        You are not affiliated with any contracts.
                    </Typography>
                </Box>
                <Box>
                    <Typography>
                        Incorrect pricing?{' '}
                        <Link to="/contact-us" style={{ color: '#0379B2' }}>
                            Contact us
                        </Link>
                    </Typography>
                </Box>
            </Box>
        </CustomCard>
    );
};

export default NoContractAffiliationCard;
